import type { Point2D, WorldRect } from "./types";

const SCENE_SCALE = 10;

export class MapCoordinates {
    constructor(private readonly worldRect: WorldRect) {}

    worldToScene(point: Point2D): Point2D {
        return {
            x: point.x * SCENE_SCALE,
            y: (this.worldTop - point.y) * SCENE_SCALE,
        };
    }

    sceneToWorld(point: Point2D): Point2D {
        return {
            x: point.x / SCENE_SCALE,
            y: this.worldTop - point.y / SCENE_SCALE,
        };
    }

    worldRectToScene(rect: WorldRect): WorldRect {
        const topLeft = this.worldToScene({
            x: rect.x,
            y: rect.y + rect.height,
        });

        return {
            x: topLeft.x,
            y: topLeft.y,
            width: this.worldLengthToScene(rect.width),
            height: this.worldLengthToScene(rect.height),
        };
    }

    sceneRectToWorld(rect: WorldRect): WorldRect {
        const bottomLeft = this.sceneToWorld({
            x: rect.x,
            y: rect.y + rect.height,
        });

        return {
            x: bottomLeft.x,
            y: bottomLeft.y,
            width: this.sceneLengthToWorld(rect.width),
            height: this.sceneLengthToWorld(rect.height),
        };
    }

    worldLengthToScene(length: number): number {
        return length * SCENE_SCALE;
    }

    sceneLengthToWorld(length: number): number {
        return length / SCENE_SCALE;
    }

    private get worldTop(): number {
        return this.worldRect.y + this.worldRect.height;
    }
}
